module.exports = __webpack_public_path__ + "img/antes_despues_248.d446e382.png";